import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";

import { listEmails } from "@/api/emails";
import type { FilterState } from "@/types/domain";

export function useEmails(filters: FilterState) {
  return useInfiniteQuery({
    queryKey: ["emails", filters],
    initialPageParam: null as string | null,
    queryFn: ({ pageParam, signal }) => listEmails(filters, pageParam, 50, signal),
    getNextPageParam: (last) => last.nextToken ?? undefined,
    placeholderData: keepPreviousData,
  });
}
